
// import React from 'react';
// import "./AboutUs.css";
// import aboutusImg from "../../Assets/images/aboutusImg.jpg"

// const AboutUs = () => {
//   return (
//     <>
//       <div className='about-us'>
//       <div className='banner-2'>
//         <div className='about-top-title'>
//           <div className='about-title'>
//             <h2>YourSalon: Run Your Salon Smoothly With Our Top Notch CRM Solutions 
//             </h2>
//           </div>
//           <div className='about-para-1'>
//             <p>We help small, medium, and large businesses run efficiently with our tailored salon management software. 
//             </p>
//           </div>
//         </div>

//          <div className='about-img-section'>
//           <div className='about-img'>
//             <img src={aboutusImg} alt='' />
//           </div>

//           <div className='about-content'>
//             <div className='content-one'>
//               <div className='scroll-content'>
//                 <p>
//                 Our mission is to assist hair, nail, and beauty salons in conducting daily business activities with ease.
//                 </p>
//               </div>
//              </div>
//                <div className='content-one'>
//               <div className='scroll-content'>
//                 <p>
//                 Track your customer data, manage appointments, sales, inventories, and many more with us.
//                 </p>
//               </div>
//              </div>

//           </div>
//         </div> 
//       </div>
//       </div>
//     </>
//   );
// }

// export default AboutUs;
import React, { useState, useEffect } from 'react';
import "./AboutUs.css";
import aboutusImg from "../../Assets/images/aboutusImg.jpg";

// Import required FontAwesome icons
import { FaCut, FaCalendarAlt, FaUsers, FaChartLine } from "react-icons/fa";

const AboutUs = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: <FaCut />,
      title: "Salon Management",
      description: "Comprehensive tools to manage all aspects of your salon business efficiently."
    },
    {
      icon: <FaCalendarAlt />,
      title: "Appointment Scheduling",
      description: "Streamline booking processes and reduce no-shows with our smart system."
    },
    {
      icon: <FaUsers />,
      title: "Client Management",
      description: "Maintain detailed client records and preferences for personalized service."
    },
    {
      icon: <FaChartLine />,
      title: "Business Analytics",
      description: "Gain insights into your business performance with detailed reports and analytics."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [features.length]);

  return (
    <>
      <div className='about-us' id="about-us">
        <div className='about-container'>
          {/* Header Section */}
          <div className='about-header'>
            <h1>YourSalon: Complete CRM Solution for Modern Salons</h1>
            <p>Empowering beauty businesses with cutting-edge software to streamline operations, enhance customer experience, and boost profitability</p>
          </div>

          {/* Main Content Section */}
          <div className='about-content-section'>
            {/* Image Section */}
            <div className='about-image-container'>
              <div className='image-wrapper'>
                <img src={aboutusImg} alt='Salon management software dashboard' />
                <div className='image-overlay'></div>
              </div>

              {/* Stats Counter */}
              <div className='stats-container'>
                <div className='stat-item'>
                  <h3>500+</h3>
                  <p>Salons Using Our Software</p>
                </div>
                <div className='stat-item'>
                  <h3>98%</h3>
                  <p>Customer Satisfaction</p>
                </div>
                <div className='stat-item'>
                  <h3>24/7</h3>
                  <p>Support Available</p>
                </div>
              </div>
            </div>

            {/* Features Section */}
            <div className='about-us-features'>
              <h2>Why Choose YourSalon?</h2>

              <div className='features-grid-about-us'>
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className={`feature-card-about-us ${activeFeature === index ? 'active' : ''}`}
                    onMouseEnter={() => setActiveFeature(index)}
                  >
                    <div className='feature-card-header'>
                      <div className='feature-icon'>{feature.icon}</div>
                      <h3>{feature.title}</h3>
                    </div>
                    <p>{feature.description}</p>
                  </div>

                ))}
              </div>

              {/* Mission Statement */}
              <div className='mission-section'>
                <div className='mission-card'>
                  <h3>Our Mission</h3>
                  <p>To revolutionize salon management by providing intuitive, powerful software that helps beauty professionals focus on what they do best - making clients look and feel beautiful.</p>
                </div>

                <div className='mission-card'>
                  <h3>What We Offer</h3>
                  <p>From appointment scheduling and client management to inventory tracking and business analytics, we provide all the tools you need to run a successful salon business.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className='about-cta'>
            <h2>Ready to Transform Your Salon Business?</h2>
            <p>Join thousands of successful salons using YourSalon to streamline their operations and grow their business.</p>
            <button className='cta-button'>Get Started Today</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
